(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('truncated-text')) {
    customElements.define(
      'truncated-text',
      class TruncatedText extends HTMLElement {
        connectedCallback() {
          this.clip = this.querySelector('[data-truncated-clip]');
          this.content = this.querySelector('[data-truncated-content]');
          this.toggle = this.querySelector('[data-truncated-toggle]');
          if (!this.clip || !this.content || !this.toggle) return;

          this.animation = null;
          this.isAnimating = false;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          this.toggle.addEventListener('click', () => this.toggleExpanded());
          this.resizeObserver = new ResizeObserver(() => this.sync());
          this.resizeObserver.observe(this.content);
          this.sync();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.animation?.cancel();
        }

        get expanded() {
          return this.hasAttribute('open');
        }

        overflows() {
          const probe = this.content.cloneNode(true);
          probe.removeAttribute('id');
          probe.style.cssText =
            'position:absolute;visibility:hidden;display:block;-webkit-line-clamp:unset;max-height:none;overflow:visible;pointer-events:none;width:' +
            this.content.clientWidth +
            'px';
          this.append(probe);
          const overflowing = probe.scrollHeight > this.clip.clientHeight + 1;
          probe.remove();
          return overflowing;
        }

        collapsedHeight() {
          const probe = this.content.cloneNode(true);
          probe.removeAttribute('id');
          probe.style.cssText =
            'position:absolute;visibility:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;pointer-events:none;width:' +
            this.content.clientWidth +
            'px';
          this.append(probe);
          const height = probe.offsetHeight;
          probe.remove();
          return height;
        }

        sync() {
          if (this.isAnimating) return;
          if (this.expanded) return;
          this.classList.toggle('is-truncated', this.overflows());
        }

        toggleExpanded() {
          if (this.isAnimating) return;
          if (this.expanded) {
            this.collapse();
          } else {
            this.expand();
          }
        }

        expand() {
          const startHeight = this.clip.offsetHeight;
          this.setAttribute('open', '');
          this.toggle.setAttribute('aria-expanded', 'true');
          this.clip.style.overflow = 'hidden';
          this.clip.style.height = `${startHeight}px`;

          requestAnimationFrame(() => {
            const endHeight = this.content.offsetHeight;
            this.animateHeight(startHeight, endHeight, true);
          });
        }

        collapse() {
          const startHeight = this.clip.offsetHeight;
          const endHeight = this.collapsedHeight();
          this.clip.style.overflow = 'hidden';
          this.clip.style.height = `${startHeight}px`;
          this.animateHeight(startHeight, endHeight, false);
        }

        animateHeight(startHeight, endHeight, open) {
          this.animation?.cancel();

          if (this.prefersReducedMotion.matches) {
            this.onAnimationFinish(open);
            return;
          }

          this.isAnimating = true;
          this.animation = this.clip.animate(
            { height: [`${startHeight}px`, `${endHeight}px`] },
            { duration: 300, easing: 'ease' }
          );
          this.animation.onfinish = () => this.onAnimationFinish(open);
          this.animation.oncancel = () => {
            this.isAnimating = false;
          };
        }

        onAnimationFinish(open) {
          this.animation = null;
          this.isAnimating = false;
          this.toggle.setAttribute('aria-expanded', String(open));

          if (open) {
            this.setAttribute('open', '');
          } else {
            this.removeAttribute('open');
          }

          this.clip.style.height = '';
          this.clip.style.overflow = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pdp-ugc-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ugc-stories')) {
    customElements.define(
      'ugc-stories',
      class UgcStories extends HTMLElement {
        connectedCallback() {
          try {
            this.videos = JSON.parse(this.querySelector('[data-ugc-videos]').textContent);
          } catch {
            this.videos = [];
          }
          this.bubble = this.querySelector('[data-ugc-open]');
          this.dialog = this.querySelector('dialog');
          this.players = [...this.querySelectorAll('[data-ugc-video]')];
          this.fills = [...this.querySelectorAll('[data-ugc-fill]')];
          this.current = this.players[0];
          this.index = 0;
          this.storageKey = `ugc-viewed:${this.dataset.productId}`;
          this.tick = this.tick.bind(this);

          try {
            if (localStorage.getItem(this.storageKey)) this.setAttribute('data-viewed', '');
          } catch {}

          this.bubble.addEventListener('click', () => this.open(0));
          this.querySelector('[data-ugc-close]')?.addEventListener('click', () => this.close());
          this.querySelectorAll('[data-ugc-step]').forEach((button) => {
            button.addEventListener('click', () => this.step(Number(button.dataset.ugcStep)));
          });
          this.querySelectorAll('[data-ugc-goto]').forEach((button) => {
            button.addEventListener('click', () => this.play(Number(button.dataset.ugcGoto)));
          });

          this.playToggle = this.querySelector('[data-ugc-toggle-play]');
          this.muteToggle = this.querySelector('[data-ugc-toggle-mute]');
          this.muted = false;
          this.querySelector('[data-ugc-stage]').addEventListener('click', () => this.togglePlay());
          this.playToggle.addEventListener('click', () => this.togglePlay());
          this.muteToggle.addEventListener('click', () => this.setMuted(!this.muted));

          // Only the current player drives the controls; crossfade pauses and
          // the pause that precedes `ended` don't count.
          this.players.forEach((player) => {
            player.addEventListener('play', () => player === this.current && this.setPausedState(false));
            player.addEventListener('pause', () => {
              if (player === this.current && !player.ended) this.setPausedState(true);
            });
          });

          this.players.forEach((player) => {
            player.addEventListener('ended', () => {
              if (player === this.current) this.play((this.index + 1) % this.videos.length);
            });
          });

          // A click on the ::backdrop targets the dialog element itself.
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog.addEventListener('keydown', (event) => {
            if (['ArrowUp', 'ArrowLeft'].includes(event.key)) this.step(-1);
            else if (['ArrowDown', 'ArrowRight'].includes(event.key)) this.step(1);
            else return;
            event.preventDefault();
          });
          // Escape closes natively (`cancel`, then `close`), bypassing close().
          this.dialog.addEventListener('cancel', () => this.cleanup());
          this.dialog.addEventListener('close', () => this.cleanup());
        }

        close() {
          if (!this.dialog.open) return;
          this.dialog.close();
          this.cleanup();
        }

        // Idempotent: may run from close(), `cancel` and `close`.
        cleanup() {
          if (!this.players.some((player) => player.hasAttribute('src'))) return;
          cancelAnimationFrame(this.frame);
          this.players.forEach((player) => {
            player.pause();
            player.removeAttribute('src');
            player.removeAttribute('poster');
            player.load();
            player.classList.remove('is-active');
            delete player.dataset.index;
          });
          document.body.style.overflowY = '';
          this.bubble.focus();
        }

        open(index) {
          this.setAttribute('data-viewed', '');
          try {
            localStorage.setItem(this.storageKey, '1');
          } catch {}
          if (!this.dialog.open) {
            this.dialog.showModal();
            document.body.style.overflowY = 'hidden';
          }
          this.play(index);
        }

        step(direction) {
          const count = this.videos.length;
          if (count < 2) return;
          this.play((this.index + direction + count) % count);
        }

        togglePlay() {
          if (this.current.paused) this.current.play().catch(() => {});
          else this.current.pause();
        }

        setPausedState(paused) {
          this.dialog.toggleAttribute('data-paused', paused);
          this.playToggle.setAttribute(
            'aria-label',
            paused ? this.playToggle.dataset.labelPlay : this.playToggle.dataset.labelPause
          );
        }

        setMuted(muted) {
          this.muted = muted;
          this.players.forEach((player) => {
            player.muted = muted;
          });
          this.dialog.toggleAttribute('data-muted', muted);
          this.muteToggle.setAttribute(
            'aria-label',
            muted ? this.muteToggle.dataset.labelUnmute : this.muteToggle.dataset.labelMute
          );
        }

        other(player) {
          return this.players.find((candidate) => candidate !== player);
        }

        load(player, index) {
          const story = this.videos[index];
          if (player.dataset.index === String(index)) return;
          player.dataset.index = index;
          player.poster = story.poster || '';
          player.src = story.src;
        }

        play(index) {
          if (!this.videos[index]) return;
          const previous = this.current;
          const next = previous.classList.contains('is-active') ? this.other(previous) : previous;
          this.index = index;
          this.current = next;
          this.load(next, index);
          next.muted = this.muted;
          // Has a frame to show yet? Check before rewinding: a seek drops
          // readyState, and a preloaded video won't fire `loadeddata` again.
          const ready = next.readyState >= 2;
          if (next.currentTime > 0) next.currentTime = 0;
          // Opened by a click, so playback with sound is allowed.
          next.play().catch(() => {});

          const reveal = () => {
            // Superseded by a later click, or already revealed.
            if (this.current !== next || next.classList.contains('is-active')) return;
            next.classList.add('is-active');
            if (previous !== next) {
              previous.classList.remove('is-active');
              previous.pause();
            }
            clearTimeout(this.preloadTimer);
            this.preloadTimer = setTimeout(() => {
              const hidden = this.other(this.current);
              if (this.videos.length > 1 && !hidden.classList.contains('is-active')) {
                hidden.preload = 'auto';
                this.load(hidden, (this.index + 1) % this.videos.length);
              }
            }, 350);
          };
          if (ready) {
            reveal();
          } else {
            // `playing` fires every time playback starts (unlike `loadeddata`);
            // the timeout guarantees the swap even if it never does.
            next.addEventListener('playing', reveal, { once: true });
            clearTimeout(this.revealTimer);
            this.revealTimer = setTimeout(reveal, 1500);
          }

          this.fills.forEach((fill, i) => {
            fill.style.transform = `scaleX(${i < index ? 1 : 0})`;
          });
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.tick);
        }

        tick() {
          if (!this.dialog.open) return;
          const { currentTime, duration } = this.current;
          const fill = this.fills[this.index];
          if (fill && duration) fill.style.transform = `scaleX(${Math.min(1, currentTime / duration)})`;
          this.frame = requestAnimationFrame(this.tick);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
